import { NavLink } from 'react-router-dom';
import {
    LayoutDashboard,
    Factory,
    ClipboardList,
    BarChart3,
    Settings,
    Boxes,
    Users,
    Activity,
    UserCog,
    Gauge,
    Wrench,
    ChevronRight,
    // CalendarDays, // Planejamento diario desativado temporariamente.
} from 'lucide-react';
import useAuthStore from '../stores/useAuthStore';

const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Painel', exact: true, group: ' principal' },
    { path: '/chao-fabrica', icon: Factory, label: 'Chão de Fábrica', group: ' principal' },
    { path: '/ordens', icon: ClipboardList, label: 'Ordens de Produção', group: ' principal' },
    { path: '/producao', icon: Activity, label: 'Produção', group: ' principal' },
    { path: '/maquinarios', icon: Boxes, label: 'Maquinário', group: ' equipamentos' },
    { path: '/manutencao', icon: Wrench, label: 'Manutenção', group: ' equipamentos' },
    { path: '/relatorios', icon: BarChart3, label: 'Relatórios', group: ' monitoramento' },
    { path: '/equipe', icon: Users, label: 'Equipe', group: ' gestão' },
    { path: '/configuracoes', icon: Settings, label: 'Configurações', group: ' gestão' },
    { path: '/usuarios', icon: UserCog, label: 'Usuários', group: ' gestão', adminOnly: true },
    // Planejamento diario desativado temporariamente para a implantacao em producao.
    // { path: '/planejamento', icon: CalendarDays, label: 'Planejamento Diário', group: ' principal' },
];

const groupLabels = {
    ' principal': null,
    ' equipamentos': 'Equipamentos',
    ' monitoramento': 'Monitoramento',
    ' gestão': 'Gestão',
};

export default function Sidebar({ isOpen }) {
    const { operadorLogado } = useAuthStore();
    // O trilho é escuro nos dois temas (grafite no escuro, azul do escudo no
    // claro), então a logo é sempre a negativa. A horizontal cabe no trilho;
    // a empilhada oficial ficava alta demais.
    const logoSrc = `${import.meta.env.BASE_URL}logo-tecnofibras-horizontal-negativo.png`;

    const filteredItems = menuItems.filter(item => {
        if (item.adminOnly) return operadorLogado?.perfil === 'admin';
        return true;
    });

    const grouped = filteredItems.reduce((acc, item) => {
        const g = item.group || ' principal';
        if (!acc[g]) acc[g] = [];
        acc[g].push(item);
        return acc;
    }, {});

    return (
        <aside
            className={`fixed left-0 top-4 bottom-4 z-40 transition-all duration-300 ease-out flex flex-col
                ${isOpen ? 'w-64' : 'w-[68px]'} trilho`}
            style={{ left: '12px' }}
        >
            {/* Branding — logo TECNOFIBRAS (escudo + logotipo). Recolhido,
                fica só o escudo. */}
            <div className={`shrink-0 ${isOpen ? 'px-4 pt-6 pb-4' : 'pt-5 pb-3 flex justify-center items-center'}`}>
                {isOpen ? (
                    <img
                        src={logoSrc}
                        alt="Tecnofibras"
                        className="w-full max-w-[200px] h-auto object-contain mx-auto"
                    />
                ) : (
                    <img
                        src={`${import.meta.env.BASE_URL}favicon.png`}
                        alt="Tecnofibras"
                        className="w-9 h-9 object-contain"
                    />
                )}
            </div>

            {/* Navigation */}
            <nav className="flex-1 overflow-y-auto custom-scrollbar-thin px-2.5 pb-3">
                {Object.entries(grouped).map(([groupKey, items]) => (
                    <div key={groupKey} className="mb-1">
                        {isOpen && groupLabels[groupKey] && (
                            <div className="flex items-center gap-2 px-3.5 pt-5 pb-2">
                                <span className="trilho__grupo">
                                    {groupLabels[groupKey]}
                                </span>
                                <span className="flex-1 h-px trilho__fio" />
                            </div>
                        )}
                        {items.map((item) => {
                            const Icon = item.icon;
                            return (
                                <NavLink
                                    key={item.path}
                                    to={item.path}
                                    end={item.exact}
                                    className={({ isActive }) =>
                                        `trilho__item flex items-center gap-2 mb-1
                                        ${isOpen ? 'px-2 py-2 mx-1' : 'px-0 py-2 justify-center mx-1'}
                                        ${isActive ? 'trilho__item--ativo' : ''}`
                                    }
                                >
                                    {({ isActive }) => (
                                        <>
                                            {/* Item ativo é a pílula em gradiente laranja do trilho do
                                                PDV; a cor vem do padrao-personalitec.css. */}
                                            <span className="shrink-0 w-7 h-7 flex items-center justify-center">
                                                <Icon size={17} strokeWidth={isActive ? 2.2 : 1.8} />
                                            </span>
                                            {isOpen && (
                                                <span className="trilho__nome truncate">{item.label}</span>
                                            )}
                                        </>
                                    )}
                                </NavLink>
                            );
                        })}
                    </div>
                ))}
            </nav>
        </aside>
    );
}
